export const EVENT_QUANTITY_INPUT_CHANGE = "quantity-input:change";

export class QuantityInput extends HTMLElement {
  min = 0;
  max = 100;
  value = 1;

  $minusButton: HTMLButtonElement;
  $plusButton: HTMLButtonElement;
  $display: HTMLDivElement;
  $input: HTMLInputElement;

  constructor() {
    super();

    const maxAttr = this.dataset.max;
    if (maxAttr) this.max = parseInt(maxAttr);

    this.$minusButton = this.querySelector(".qty-minus")!;
    this.$plusButton = this.querySelector(".qty-plus")!;
    this.$display = this.querySelector(".qty-display")!;
    this.$input = this.querySelector('input[name="quantity"]')!;
  }

  connectedCallback() {
    this.$minusButton.addEventListener("click", this.onMinusClick.bind(this));
    this.$plusButton.addEventListener("click", this.onPlusClick.bind(this));
  }

  onMinusClick() {
    this.value = this.value <= 1 ? 1 : this.value - 1;
    this.updateValue();
  }

  onPlusClick() {
    this.value = this.value === this.max ? this.max : this.value + 1;
    this.updateValue();
  }

  updateValue() {
    this.$display.innerText = this.value.toString();
    this.$input.value = this.value.toString();
    document.dispatchEvent(new CustomEvent(EVENT_QUANTITY_INPUT_CHANGE, { detail: { quantity: this.value } }))
  }

  reset() {
    this.value = 1;
    this.updateValue();
  }
}

customElements.define("quantity-input", QuantityInput);
